import {sessionCache} from "../../utils/session_cache";
import {IGenericBoostersConfig} from "../types/IGenericBoostersConfig";

const getBoosterStorageKey = (offerId: string | number, propertyId?: string | number) => {
    const id = propertyId ? `${offerId}_${propertyId}` : `${offerId}`;
    return `booster_${id}`;
};

const isValidStorageRecord = <TBoosterParams extends object>(
    record: unknown
): record is {
    category: keyof IGenericBoostersConfig<TBoosterParams>;
    type: keyof IGenericBoostersConfig<TBoosterParams>[keyof IGenericBoostersConfig<TBoosterParams>];
} => {
    return typeof record === "object" && record !== null && "category" in record && "type" in record;
};

export const saveBoosterToStorage = <TBoosterParams extends object>(
    category: keyof IGenericBoostersConfig<TBoosterParams>,
    type: IGenericBoostersConfig<TBoosterParams>[keyof IGenericBoostersConfig<TBoosterParams>],
    offerId: string | number,
    propertyId?: string | number
) => {
    const key = getBoosterStorageKey(offerId, propertyId);
    sessionCache.set(key, {category, type});
};

export const getBoosterFromStorage = <TBoosterParams extends object>(
    offerId: string | number,
    propertyId?: string | number
): {
    category: keyof IGenericBoostersConfig<TBoosterParams>;
    type: keyof IGenericBoostersConfig<TBoosterParams>[keyof IGenericBoostersConfig<TBoosterParams>];
} | null => {
    const key = getBoosterStorageKey(offerId, propertyId);
    const record = sessionCache.get(key);

    return isValidStorageRecord(record) ? record : null;
};
import {sessionCache} from "../../utils/session_cache";
import {IGenericBoostersConfig} from "../types/IGenericBoostersConfig";

const getBoosterStorageKey = (offerId: string | number, propertyId?: string | number) => {
    const id = propertyId ? `${offerId}_${propertyId}` : `${offerId}`;
    return `booster_${id}`;
};

const isValidStorageRecord = <TBoosterParams extends object>(
    record: unknown
): record is {
    category: keyof IGenericBoostersConfig<TBoosterParams>;
    type: keyof IGenericBoostersConfig<TBoosterParams>[keyof IGenericBoostersConfig<TBoosterParams>];
} => {
    return typeof record === "object" && record !== null && "category" in record && "type" in record;
};

export const saveBoosterToStorage = <TBoosterParams extends object>(
    category: keyof IGenericBoostersConfig<TBoosterParams>,
    type: IGenericBoostersConfig<TBoosterParams>[keyof IGenericBoostersConfig<TBoosterParams>],
    offerId: string | number,
    propertyId?: string | number
) => {
    const key = getBoosterStorageKey(offerId, propertyId);
    sessionCache.set(key, {category, type});
};

export const getBoosterFromStorage = <TBoosterParams extends object>(
    offerId: string | number,
    propertyId?: string | number
): {
    category: keyof IGenericBoostersConfig<TBoosterParams>;
    type: keyof IGenericBoostersConfig<TBoosterParams>[keyof IGenericBoostersConfig<TBoosterParams>];
} | null => {
    const key = getBoosterStorageKey(offerId, propertyId);
    const record = sessionCache.get(key);

    return isValidStorageRecord(record) ? record : null;
};
